export const shouldLimitAccess = ({ active, content }) => {
  return active && content === null;
};
